// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","204":"FullCake"}[chunkId] + "." + {"72":"7840b73f","187":"fb4c9d46","204":"01bc2396"}[chunkId] + ".chunk.js";
};